import { render, staticRenderFns } from "./PurchaseOrderItemSetup.vue?vue&type=template&id=b739ec8e&"
import script from "./PurchaseOrderItemSetup.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderItemSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports